import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter } from "react-router-dom";
import App from './components/app/App';
import './polyfills';
//import registerServiceWorker from './registerServiceWorker';
import './global/css/global.css'

render((
    <BrowserRouter>
        <App />
    </BrowserRouter>
), document.getElementById('root'));

//registerServiceWorker();
